import axios from 'axios'

export default {
    namespaced: true,
    state: {
        currencies: [],
        hotelsWithCurrency: []
    },
    mutations: {
        CLEAR_DATA(state) {
            state.currencies = []
        },
        FETCH_CURRENCY(state, payload) {
            state.currencies = payload
        },
        ADD_CURRENCY(state, currency) {
            state.currencies.push(currency)
        },
        EDIT_CURRENCY(state, payload) {
            const index = state.currencies.findIndex(
                item => item.char_code === payload.char_code
            )
            if (index !== -1) {
                Object.assign(state.currencies[index], payload.data)
            }
        },
        DEL_CURRENCY(state, currency) {
            const index = state.currencies.findIndex(
                item => item.char_code === currency
            )
            if (index !== -1) {
                state.currencies.splice(index, 1)
            }
        },
        FETCH_CONN_HOTELS(state, payload) {
            state.hotelsWithCurrency = payload
        },
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.currencies.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/root/currency/list'
                    ).then(({data}) => {
                        commit('FETCH_CURRENCY', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/currency/add',
                    data
                ).then(({data}) => {
                    commit('ADD_CURRENCY', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/currency/edit/' + payload.char_code,
                    payload
                ).then(({data}) => {
                    commit('EDIT_CURRENCY', {data: data.data, char_code: payload.char_code})
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        changeBase({dispatch, commit}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/currency/change/' + payload.cСС,
                    {char_code: payload.cСС}
                ).then(({data}) => {
                    console.log(data.data)
                    commit('FETCH_CURRENCY', data.data.allCurrencies)
                    // resolve(data.data.hotelsWithCurrency)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        connectHotel({dispatch, commit}, payload) {
            console.log(payload)
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/currency/connect',
                    {id: payload.currencyId, hotelIds: payload.hotelIds}
                ).then(({data}) => {
                    commit('FETCH_CONN_HOTELS', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemCharCode) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/currency/dell/' + itemCharCode,
                    {char_code: itemCharCode}
                ).then(({data}) => {
                    commit('DEL_CURRENCY', itemCharCode)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetchHotelsWithCurrency({dispatch, commit}) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/root/currency/with-hotels'
                ).then(({data}) => {
                    commit('FETCH_CONN_HOTELS', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        withThis({dispatch, commit}, currId){
            return new Promise((resolve)=>{
                axios.post(
                    '/api/root/currency/with-this/'+currId,
                    {char_code: currId}
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        clear({commit}) {
            commit('CLEAR_DATA')
        }
    }
}

